
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component({})
export default class PelletsArticle extends Vue {
  @Prop({ required: true }) title!: string;
  @Prop({ required: true }) contentParagraphs!: string[];
  @Prop({ required: true }) imageSrc!: string;
  @Prop({ default: "" }) imageAlt!: string;
  @Prop({ default: "left" }) imagePosition!: "left" | "right";
}
